import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
	basketItem: {
		position: 'relative',
		backgroundSize: 'cover',
		backgroundPosition: 'center'
	},
	basketItemLandscape: {
		paddingBottom: '92.5%'
	},
	basketItemPortrait: {
		paddingBottom: '140%'
	},
	actionsMobileButton: {
		pointerEvents: 'all',
		padding: 6
	},
	actionsMobileIcon: {
		color: 'white',
		fontSize: 23
	}
}));